<app-title-section></app-title-section>

<div class="card mb-1 " style="margin-left: 15px; margin-right: 15px" *ngFor="let warehouse of warehouses">
    <div class="card-body ">
        <div class="mb-1 d-flex justify-content-between align-items-center flex-wrap">
            <h4 class="mb-0"> {{ warehouse.name }} </h4>
            <div class="d-flex align-items-center" style="gap:16px">
                <ng-container>
                    <!--   <button class="btn btn-primary mx-1" (click)="openAjoutModal()">
                          + Ajouter
                       </button>-->
                    <button class="btn btn-primary" (click)="openAddModal(warehouse.type_solde)">
                        Ajouter une dépense
                    </button>
                    <button class=" dtailsStyle" (click)="openRemiseBanqueModal(warehouse.type_solde)" >
                        Remsie en banque
                    </button>


                    <button class="btn btn-primary" (click)="openSaveModal(warehouse.type_solde)" >
                        Enregistrer l'opération
                    </button>

                    <button class="bouttonStyle" (click)="detailTresorerie(warehouse.type_solde)">

                        <i data-feather="eye" [size]="18"></i>
                    </button>

                </ng-container>
            </div>
        </div>

        <div class="mb-2">
            <label class="size32"> {{ warehouse.stockValue.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3}) }}  TND</label>
        </div>

        <div class="items styleBorder col-lg-12">

            <div class="item col-lg-3 pl-0">
                <div class=" d-flex mb-1">
                    <div class="iconDesing2">
                        <i data-feather="scissors" [size]="16"></i>
                    </div>
                    <div>
                        <label class="mx-1 size15" style="margin-top: 2px">Retenue </label>
                    </div>

                </div>
                <div class="">

                    <label class="size24 "> {{ formatMontant(warehouse.retenue || 0) }} </label>
                </div>
                <div style=" border-bottom: 4px solid #2F2B3D14; border-radius: 2px "> </div>

            </div>
            <div class="item col-lg-3">
                <div class=" d-flex mb-1">
                    <div class="iconDesing">
                        <i data-feather="file-text" [size]="18"></i>
                    </div>
                    <div>
                        <label class="mx-1 size15" style="margin-top: 2px">Traites </label>
                    </div>

                </div>
                <div class="">

                    <label class="size24 "> {{ formatMontant(warehouse.traites || 0) }} </label>
                </div>
                <div style=" border-bottom: 4px solid #2F2B3D14; border-radius: 2px "> </div>
            </div>
            <div class="item col-lg-3">
                <div class=" d-flex mb-1">
                    <div class="iconDesing3">
                        <i data-feather="credit-card" [size]="18"></i>

                    </div>
                    <div>
                        <label class="mx-1 size15" style="margin-top: 2px">Chèques </label>
                    </div>

                </div>
                <div class="">

                    <label class="size24 "> {{ formatMontant(warehouse.cheques || 0) }} </label>
                </div>
                <div style=" border-bottom: 4px solid #2F2B3D14; border-radius: 2px "> </div>
            </div>
            <div class="item col-lg-3">
                <div class=" d-flex mb-1">
                    <div class="iconDesing4">
                        <i data-feather="dollar-sign" [size]="16"></i>
                    </div>
                    <div>
                        <label class="mx-1 size15" style="margin-top: 2px">Espèce </label>
                    </div>

                </div>
                <div class="">

                    <label class="size24 "> {{ formatMontant(warehouse.espece || 0) }} </label>
                </div>
                <div style=" border-bottom: 4px solid #2F2B3D14; border-radius: 2px "> </div>
            </div>
        </div>


    </div>
</div>

<app-ajout-solde #ajoutSolde (soldeCreated)="onSoldeCreated()"></app-ajout-solde>

<app-add-depense #addDepense (depenseCreated)="onDepenseCreated()"></app-add-depense>

<app-save #save></app-save>
<app-remise-banque #remiseBanque (remiseCreated)="onRemiseCreated()"></app-remise-banque>